/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Unfreeze_Confirm_BillingInputs */



/**
* | output |
* | --- |
* | "The billing clock restarts today, so the part-period from before the suspension is written off and never billed." |
*
* @param {Partner_Org_Unfreeze_Confirm_BillingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_unfreeze_confirm_billing = /** @type {((inputs?: Partner_Org_Unfreeze_Confirm_BillingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Unfreeze_Confirm_BillingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Abrechnungsperiode startet heute neu; der Teilzeitraum vor der Sperre wird abgeschrieben und nie berechnet.")
	return /** @type {LocalizedString} */ ("The billing clock restarts today, so the part-period from before the suspension is written off and never billed.")
});